module.exports = __webpack_public_path__ + "static/media/review5.cfd768a1.webp";